import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { palette } from '../../assets/styles/themes/tokens';
import { colors } from '../../assets/styles/themes/variables';
import GreetingUnderline from '../../assets/greetingUnderline.svg';
import getGreeting from './getGreeting';

const GREETING_REFRESH_INTERVAL_MS = 60_000;
const FIRST_LOGIN_GREETING_KEY = 'Welcome';

interface DashboardPageHeaderProps {
  firstName?: string;
  isFirstLogin?: boolean;
}

const DashboardPageHeader: React.FC<DashboardPageHeaderProps> = ({ firstName, isFirstLogin }) => {
  const { t } = useTranslation();
  const [greetingKey, setGreetingKey] = useState(() => getGreeting(new Date()));

  // Keep a long-open tab from showing a stale greeting after a time band flips;
  // setState with an unchanged key skips the re-render.
  useEffect(() => {
    const interval = setInterval(() => {
      setGreetingKey(getGreeting(new Date()));
    }, GREETING_REFRESH_INTERVAL_MS);
    return () => clearInterval(interval);
  }, []);

  const greeting = t(isFirstLogin ? FIRST_LOGIN_GREETING_KEY : greetingKey);

  return (
    <Box sx={{ width: 'fit-content' }}>
      <Typography
        variant='h5'
        sx={{ color: palette.text.primary }}>
        {firstName ? `${greeting}, ${firstName}` : greeting}
      </Typography>
      <Box
        component={GreetingUnderline}
        data-testid='greeting-underline'
        aria-hidden='true'
        preserveAspectRatio='none'
        sx={{ display: 'block', width: '40%', height: 8, color: colors.green400 }}
      />
    </Box>
  );
};

export default DashboardPageHeader;
